import {
  PlanningEvent,
  PlanningStatus,
  PlanningSeverity,
} from "../models/planning-event.model";

export function dechargementsToPlanningEvents(
  dechargements: any[],
): PlanningEvent[] {
  if (!dechargements?.length) return [];

  return dechargements
    .filter((d) => d.date != null)
    .map((d) => {
      const { status, severity } = deriveDechStatus(d);
      const bl = d.numeroBonLivraison ?? "";
      // Accept two shapes: (1) full Dechargement with nested commande/tiers/lignes
      // (legacy loadAll) ; (2) lightweight DTO from /dechargements/planning with
      // flat fournisseur/commandeNumero/dateLivraisonPrevue + aggregated totals.
      const fournisseur =
        d.commande?.tiers?.denomination ?? d.fournisseur ?? "";
      const cmdNumero = d.commande?.numero ?? d.commandeNumero ?? "";

      const qteConforme =
        d.totalQuantiteConforme ??
        d.lignes?.reduce(
          (acc: number, l: any) => acc + (l.quantiteConforme ?? 0),
          0,
        ) ?? 0;
      const qteNC =
        d.totalQuantiteNonConforme ??
        d.lignes?.reduce(
          (acc: number, l: any) => acc + (l.quantiteNonConforme ?? 0),
          0,
        ) ?? 0;

      return {
        id: `dechargement:${d.id}`,
        source: "dechargement" as const,
        kind: "reception",
        reference: {
          label: fournisseur || `BL ${bl}`,
          route: [`/commandes/details/id/${d.commandeId}/dechargement`],
        },
        datePrevu: (d.commande?.dateLivraisonPrevue ?? d.dateLivraisonPrevue)
          ? new Date(d.commande?.dateLivraisonPrevue ?? d.dateLivraisonPrevue).toISOString()
          : new Date(d.date).toISOString(),
        dateReel: new Date(d.date).toISOString(),
        status,
        severity,
        quantite: {
          prevu:
            d.totalQuantite ??
            d.lignes?.reduce(
              (acc: number, l: any) => acc + (l.quantite ?? 0),
              0,
            ) ?? undefined,
          reel: qteConforme + qteNC || undefined,
          unite: "pal",
        },
        payload: {
          fournisseur,
          bl: bl ? `BL ${bl}` : "",
          numero: cmdNumero ?? "",
          etat: d.etat,
          etatLabel: d.etat === "FINISHED" ? "Terminé" : "En cours",
          qteNC: qteNC > 0 ? `${qteNC} NC` : "",
        },
      } satisfies PlanningEvent;
    });
}

function deriveDechStatus(d: any): {
  status: PlanningStatus;
  severity: PlanningSeverity;
} {
  const qteNC =
    d.totalQuantiteNonConforme ??
    d.lignes?.reduce(
      (acc: number, l: any) => acc + (l.quantiteNonConforme ?? 0),
      0,
    ) ?? 0;
  if (qteNC > 0) return { status: "blocked", severity: 3 };
  if (d.etat === "FINISHED") return { status: "completed", severity: 0 };
  return { status: "in_progress", severity: 0 };
}
